import { Outlet } from 'react-router-dom'
import React from 'react'

const UploadAndAccess = () => {
  return (
    <Outlet/>
  )
}

export default UploadAndAccess
